<div class="row">
  <div class="col-12">
    <div class="card mt-3">
      <div class="card-header">
        <div class="row align-items-center justify-content-between">
          <div class="col-4 col-sm-auto d-flex align-items-center pr-0">
            <h5 class="fs-0 mb-0 text-nowrap py-2 py-xl-0">Assemblies</h5>
          </div>
          <div class="col-8 col-sm-auto ml-auto text-right pl-0">

            <div id="divSearchFilter" class="d-inline-block position-relative mr-2" (click)="searchInputOperation()">
              <input type="search" id="inputSearchFilter" class="form-control form-control-sm" [(ngModel)]="searchAssembly"
                     (keyup)="getSearchData(searchAssembly)" (input)="getSearchData(searchAssembly)"
                     placeholder="Search..." autocomplete="off" appTrimLeft />
            </div>

            <button class="btn btn-sm btn-danger" [hidden]="_pluginservice.checkedList?.length==0"
                    data-toggle="modal" type="button" (click)="modalDelete(0,'','',['assemblyStatus'])">
              <span class="fas fa-trash-alt d-inline-block d-sm-none"
                    data-fa-transform="shrink-3 down-2"></span>
              <span class="d-none d-sm-inline-block">
                Delete({{_pluginservice.checkedList.length}})
              </span>
            </button>




            <button class="btn btn-sm btn-primary ml-2" [hidden]="_pluginservice.checkedList?.length==0"
                    data-toggle="modal" type="button" (click)="getExportData('pdf')">
              <span class="fas fa-export d-inline-block d-sm-none"
                    data-fa-transform="shrink-3 down-2"></span>
              <span class="d-none d-sm-inline-block">
                PDF DataSheet({{_pluginservice.checkedList.length}})
              </span>
            </button>


            <button class="btn btn-sm btn-success ml-2" [hidden]="_pluginservice.checkedList?.length==0"
                    data-toggle="modal" type="button" (click)="getExportData('excell')">
              <span class="fas fa-export d-inline-block d-sm-none"
                    data-fa-transform="shrink-3 down-2"></span>
              <span class="d-none d-sm-inline-block">
                Excell Export({{_pluginservice.checkedList.length}})
              </span>
            </button>

            <button class="btn btn-sm btn-default ml-2" [hidden]="_pluginservice.checkedList?.length==0"
                    data-toggle="modal" type="button" (click)="batchInspection()">
              <span class="fas fa-edit d-inline-block d-sm-none"
                    data-fa-transform="shrink-3 down-2"></span>
              <span class="d-none d-sm-inline-block">
                Batch Inspection ({{_pluginservice.checkedList.length}})
              </span>
            </button>



            <button class="btn btn-success rounded btn-sm" type="button" [hidden]="_pluginservice.checkedList?.length!=0" (click)="editAssembly(0,'new',0)">
              <span class="fas fa-plus d-inline-block d-sm-none"
                    data-fa-transform="shrink-3 down-2"></span>
              <span class="d-none d-sm-inline-block">
                Create new
              </span>
            </button>
            <!--<button class="btn btn-success rounded btn-sm" type="button"  (click)="sendHolcim()"> send Holcim</button>
            <button class="btn btn-danger rounded btn-sm" type="button"  (click)="deleteHolcim()"> delete Holcim</button>-->

          </div>
        </div>
      </div>
      <div class="card-body bg-light p-0">
        <div [style.opacity]="loading ? '0' : '1'">
          <div class="card-body p-0 card-scroll" (scroll)="onScrollData($event)">
            <div class="falcon-data-table">
              <div class="falcon-data-table table-responsive">
                <table class="table table-sm mb-0 table-striped border-bottom">
                  <thead class="bg-200 text-900 sticky-header">
                    <tr>
                      <th class="pr-1 align-middle w-30px">
                        <div class="custom-control custom-checkbox">
                          <input class="custom-control-input checkbox-bulk-select"
                                 id="assemblyBulk" type="checkbox"
                                 [(ngModel)]="_pluginservice.masterSelected"
                                 (change)="_pluginservice.checkAll(assemblyList,'assemblyBulk')"
                                 [disabled]="assemblyList?.length==0"
                                 [attr.checked]="_pluginservice.checkedList.length==assemblyList?.length ? 'checked' : null"
                                 [attr.indeterminate]="(_pluginservice.checkedList.length>0) && _pluginservice.checkedList.length!=assemblyList?.length ? 'indeterminate' : false"
                                 [indeterminate]="(_pluginservice.checkedList.length>0) && _pluginservice.checkedList.length!=assemblyList?.length ? 'indeterminate' : false" />
                          <label class="custom-control-label" for="assemblyBulk"></label>
                        </div>
                      </th>
                      <th class="pr-1 align-middle cursor-pointer text-left" (click)="sortType = 'serialNo'; sortReverse = !sortReverse;sortData('serialNo');">
                        Serial №
                        <span *ngIf="sortType == 'serialNo' && !sortReverse">
                          <i class="fas fa-sort-up"></i>
                        </span>
                        <span *ngIf="sortType == 'serialNo' && sortReverse">
                          <i class="fas fa-sort-down"></i>
                        </span>
                      </th>
                      <th class="pr-1 align-middle cursor-pointer text-left" (click)="sortType = 'locTagNo'; sortReverse = !sortReverse;sortData('locTagNo');">
                        Loc Tag №
                        <span *ngIf="sortType == 'locTagNo' && !sortReverse">
                          <i class="fas fa-sort-up"></i>
                        </span>
                        <span *ngIf="sortType == 'locTagNo' && sortReverse">
                          <i class="fas fa-sort-down"></i>
                        </span>
                      </th>
                      <th class="pr-1 align-middle cursor-pointer text-left min-w-100px" (click)="sortType = 'eqpPackage'; sortReverse = !sortReverse;sortData('eqpPackage');">
                        EQ Package
                        <span *ngIf="sortType == 'eqpPackage' && !sortReverse">
                          <i class="fas fa-sort-up"></i>
                        </span>
                        <span *ngIf="sortType == 'eqpPackage' && sortReverse">
                          <i class="fas fa-sort-down"></i>
                        </span>
                      </th>
                      <th class="pr-1 align-middle cursor-pointer text-left assembly-customer-col" (click)="sortType = 'customerName'; sortReverse = !sortReverse;sortData('customerName');">
                        Customer
                        <span *ngIf="sortType == 'customerName' && !sortReverse">
                          <i class="fas fa-sort-up"></i>
                        </span>
                        <span *ngIf="sortType == 'customerName' && sortReverse">
                          <i class="fas fa-sort-down"></i>
                        </span>
                      </th>
                      <th class="pr-1 align-middle cursor-pointer text-left min-w-30px" (click)="sortType = 'condition'; sortReverse = !sortReverse;sortData('condition');">
                        Condition
                        <span *ngIf="sortType == 'condition' && !sortReverse">
                          <i class="fas fa-sort-up"></i>
                        </span>
                        <span *ngIf="sortType == 'condition' && sortReverse">
                          <i class="fas fa-sort-down"></i>
                        </span>
                      </th>

                      <th class="pr-1 align-middle cursor-pointer text-center min-w-30px" (click)="sortType = 'inspectorName'; sortReverse = !sortReverse;sortData('inspectorName');">
                        Inspector
                        <span *ngIf="sortType == 'inspectorName' && !sortReverse">
                          <i class="fas fa-sort-up"></i>
                        </span>
                        <span *ngIf="sortType == 'inspectorName' && sortReverse">
                          <i class="fas fa-sort-down"></i>
                        </span>
                      </th>


                      <th class="pr-1 align-middle cursor-pointer text-center min-w-30px" (click)="sortType = 'inspectionDate'; sortReverse = !sortReverse;sortData('inspectionDate');">
                        Insp. Date
                        <span *ngIf="sortType == 'inspectionDate' && !sortReverse">
                          <i class="fas fa-sort-up"></i>
                        </span>
                        <span *ngIf="sortType == 'inspectionDate' && sortReverse">
                          <i class="fas fa-sort-down"></i>
                        </span>
                      </th>
                      <th class="pr-1 align-middle cursor-pointer text-center min-w-30px" (click)="sortType = 'nextInspectionDate'; sortReverse = !sortReverse;sortData('nextInspectionDate');">
                        Next Insp. Date
                        <span *ngIf="sortType == 'nextInspectionDate' && !sortReverse">
                          <i class="fas fa-sort-up"></i>
                        </span>
                        <span *ngIf="sortType == 'nextInspectionDate' && sortReverse">
                          <i class="fas fa-sort-down"></i>
                        </span>
                      </th>

                      <th class="pr-1 align-middle cursor-pointer text-center min-w-30px" (click)="sortType = 'expDate'; sortReverse = !sortReverse;sortData('expDate');">
                        Exp. Date
                        <span *ngIf="sortType == 'expDate' && !sortReverse">
                          <i class="fas fa-sort-up"></i>
                        </span>
                        <span *ngIf="sortType == 'expDate' && sortReverse">
                          <i class="fas fa-sort-down"></i>
                        </span>
                      </th>
                      <th class="pr-1 align-middle cursor-pointer text-left min-w-30px" (click)="sortType = 'media'; sortReverse = !sortReverse;sortData('media');">
                        Media
                        <span *ngIf="sortType == 'media' && !sortReverse">
                          <i class="fas fa-sort-up"></i>
                        </span>
                        <span *ngIf="sortType == 'media' && sortReverse">
                          <i class="fas fa-sort-down"></i>
                        </span>
                      </th>
                      <th class="pr-1 align-middle cursor-pointer text-center min-w-30px" (click)="sortType = 'class'; sortReverse = !sortReverse;sortData('class');">
                        Class
                        <span *ngIf="sortType == 'class' && !sortReverse">
                          <i class="fas fa-sort-up"></i>
                        </span>
                        <span *ngIf="sortType == 'class' && sortReverse">
                          <i class="fas fa-sort-down"></i>
                        </span>
                      </th>
                      <th class="pr-1 align-middle">
                      </th>
                    </tr>
                  </thead>
                  <tbody id="assemblyBody">
                    <tr class="btn-reveal-trigger" *ngFor="let al of assemblyList" (dblclick)="editAssembly(al.id,'edit',al.statusId)">
                      <td class="align-middle">
                        <div class="custom-control custom-checkbox" *ngIf="!al.reserved">
                          <input class="custom-control-input checkbox-bulk-select-target" type="checkbox" id="al{{al.id}}"
                                 [(ngModel)]="al.checkboxOpe"
                                 (change)="_pluginservice.isAllSelected(assemblyList);getCheckedId(al.id)" />
                          <label class="custom-control-label" for="al{{al.id}}"></label>
                        </div>
                      </td>
                      <th class="align-middle text-left">
                        <a href="javascript:void(0)" *ngIf="userType!=3 || (userType==3 && al.statusId==1)" (click)="editAssembly(al.id,'edit',al.statusId)">
                          {{al.serialNo}}
                        </a>
                        <strong *ngIf="userType==3 && al.statusId!=1">{{al.serialNo}}</strong>
                      </th>
                      <td class="align-middle text-left">
                        <strong>{{al.locTagNo}}</strong>
                      </td>
                      <td class="align-middle text-left">
                        {{al.eqpPackage}}
                      </td>
                      <td class="align-middle text-left assembly-customer-col" title="{{al.customerName}}">
                        <span class="table-desc-three-dot d-block">{{al.customerName}}</span>
                      </td>
                      <td class="align-middle text-left">
                        {{al.condition}}
                      </td>



                      <td class="align-middle">
                        <a>
                          <div class="media d-flex align-items-center justify-content-center">
                            <div class="avatar avatar-xl mr-2">
                              <img class="rounded-circle" *ngIf="al.inspectorImg?.length>0" src="{{al.inspectorImg}}" alt="" data-toggle="tooltip" data-placement="top" title="{{al.inspectorName}}">
                              <span class="circle-user-icon" *ngIf="al.inspectorImg?.length==0" data-toggle="tooltip" data-placement="top" title="{{al.inspectorName}}"><i class="fas fa-user"></i></span>
                            </div>
                          </div>
                        </a>
                      </td>



                      <td class="align-middle text-center">
                        {{al.inspectionDate}}
                      </td>
                      <td class="align-middle text-center">
                        {{al.nextInspectionDate}}
                      </td>
                      <td class="align-middle text-center">
                        {{al.expDate}}
                      </td>
                      <td class="align-middle text-left">
                        {{al.media}}
                      </td>
                      <td class="align-middle text-center">
                        {{al.class}}
                      </td>
                      <td class="align-middle white-space-nowrap">
                        <div class="dropdown text-sans-serif" id="threeNo{{al.id}}">
                          <button class="btn btn-link text-600 btn-sm dropdown-toggle btn-reveal mr-3"
                                  type="button" id="dropdown0"
                                  data-toggle="dropdown"
                                  data-boundary="html"
                                  aria-haspopup="true"
                                  aria-expanded="false">
                            <span class="fas fa-ellipsis-h fs--1"></span>
                          </button>
                          <div class="dropdown-menu dropdown-menu-right border py-0"
                               aria-labelledby="dropdown0">
                            <div class="bg-white py-2">
                              <a class="dropdown-item cursor-pointer" (click)="editAssembly(al.id,'edit',al.statusId)" *ngIf="userType!=3 || (userType==3 && al.statusId==1)">Edit</a>
                              <a class="dropdown-item cursor-pointer" (click)="editAssembly(al.id,'view',al.statusId,0)">View</a>
                              <a class="dropdown-item cursor-pointer" (click)="editAssembly(al.id,'reinspection',0)" *ngIf="userType!=3 || (userType==3 && (al.statusId==2 ||  al.statusId==1))">Re-Inspection</a>
                              <a class="dropdown-item cursor-pointer" (click)="editAssembly(al.id,'duplicate',0)" *ngIf="userType!=3 || (userType==3 && al.statusId==1)">Duplicate</a>
                              <div class="dropdown-divider" *ngIf="!al.reserved && userType!=3 || (userType==3 && al.statusId==1)"></div>
                              <a class="dropdown-item text-danger" *ngIf="!al.reserved && userType!=3 || (userType==3 && al.statusId==1)" href="javascript:void(0)" (click)="modalDelete(al.id,'assembly','delete',[])">Delete</a>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody class="text-center w-100 py-3 bg-light" *ngIf="assemblyList?.length == 0">
                    <tr>
                      <td colspan="10" class="px-2 py-3 bg-light text-center w-100">
                        <p class="text-center bold-text font-size18px m-0">No data available</p>
                        <p class="text-center m-0 text-gray font-size13px">There is nothing to show you right now</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <ngx-loading [show]="loading"></ngx-loading>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal Assembly-->
<div class="modal fade" id="assemblyModal" tabindex="-1" role="dialog" aria-labelledby="assemblyModal" data-backdrop="static" data-keyboard="false"
     aria-hidden="true" (keydown.esc)="modalAssemblyClose()">
  <div class="modal-dialog modal-width100per m-0 ui-draggable" role="document">
    <div class="modal-content ">
      <div class="modal-header">
        <h5 class="modal-title">{{modalTitleAssembly}}</h5>


        <button class="btn btn-falcon-default btn-sm ml-4" (click)="files(0,1)" *ngIf="assemblyObj.fileCount==0">
          <span class="d-sm-none d-inline-block"><i class="fas fa-upload"></i></span>
          <span class="d-sm-inline-block d-none"><i class="fas fa-cloud-upload-alt"></i></span>
          <span class="d-sm-inline-block d-none ml-2">
            Files (0)
          </span>
        </button>
        <button class="btn btn-primary btn-sm ml-4" (click)="files(0,1)" *ngIf="assemblyObj.fileCount>0">
          <span class="d-sm-none d-inline-block"><i class="fas fa-upload"></i></span>
          <span class="d-sm-inline-block d-none"><i class="fas fa-cloud-upload-alt"></i></span>
          <span class="d-sm-inline-block d-none ml-2">
            Files ({{assemblyObj.fileCount}})
          </span>
        </button>






        <button class="btn btn-falcon-default btn-sm ml-4" (click)="files(0,2)" *ngIf="assemblyObj.wfileCount==0">
          <span class="d-sm-none d-inline-block"><i class="fas fa-upload"></i></span>
          <span class="d-sm-inline-block d-none"><i class="fas fa-cloud-upload-alt"></i></span>
          <span class="d-sm-inline-block d-none ml-2">
            Wellt Files (0)
          </span>
        </button>
        <button class="btn btn-primary btn-sm ml-4" (click)="files(0,2)" *ngIf="assemblyObj.wfileCount>0">
          <span class="d-sm-none d-inline-block"><i class="fas fa-upload"></i></span>
          <span class="d-sm-inline-block d-none"><i class="fas fa-cloud-upload-alt"></i></span>
          <span class="d-sm-inline-block d-none ml-2">
            Wellt Files ({{assemblyObj.wfileCount}})
          </span>
        </button>




        <button class="close" type="button" aria-label="Close" (click)="modalAssemblyClose()">
          <span class="font-weight-light" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body " id="assembyBody" style="padding: 0 2rem !important;">

        <div class="row">
          <!--LOCATION & ROLE-->
          <div class="col-4" [ngClass]="reinspectionOpe ? 'pointer-event-disabled' : '' ">


            <div class="row">
              <div class="col-7 mt-1">
                <div>
                  <b>Location & Role</b>
                </div>
                <span class="text-muted d-block fs-12">Enter Location & Role Information</span>
              </div>
              <div class="col-12">
                <hr class="border-dashed border-bottom-0 mt-1 mb-2" />
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_customerCode" class="fs-12 mb-0 text400">
                  Company
                  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_customerCode" id="txt_customerCode" class="form-control form-control-sm pr-25px" title="Customer Code" tabindex="1" autocomplete="on" (focusout)="getAssemblyDataByCode(assemblyObj.companyCode, 'company')" [(ngModel)]="assemblyObj.companyCode" appSelectedInput />
                </div>
              </div>
              <div class="col-6">
                <input type="text" name="txt_customerName" id="txt_customerName" class="form-control form-control-sm" title="Customer" tabindex="2" autocomplete="on" [(ngModel)]="assemblyObj.companyName" appSelectedInput />
              </div>
            </div>


            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_assetCode" class="fs-12 mb-0 text400">
                  Asset
                  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_assetCode" id="txt_assetCode" class="form-control form-control-sm" title="Asset Code" tabindex="3" autocomplete="on" (focusout)="getAssemblyDataByCode(assemblyObj.assetCode, 'asset')" [(ngModel)]="assemblyObj.assetCode" appSelectedInput />
                </div>
              </div>
              <div class="col-6">
                <input type="text" name="txt_assetName" id="txt_assetName" class="form-control form-control-sm" title="Asset" tabindex="4" autocomplete="on" [(ngModel)]="assemblyObj.assetName" appSelectedInput />
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_deckCode" class="fs-12 mb-0 text400">
                  Deck
                  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_deckCode" id="txt_deckCode" class="form-control form-control-sm" title="Deck Code" tabindex="5" autocomplete="on" (focusout)="getAssemblyDataByCode(assemblyObj.deckCode, 'deck')" [(ngModel)]="assemblyObj.deckCode" appSelectedInput />
                </div>
              </div>
              <div class="col-6">
                <input type="text" name="txt_deckName" id="txt_deckName" class="form-control form-control-sm" title="Deck" tabindex="6" autocomplete="on" [(ngModel)]="assemblyObj.deckName" appSelectedInput />
              </div>
            </div>


            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_moduleCode" class="fs-12 mb-0 text400">
                  Module
                  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_moduleCode" id="txt_moduleCode" class="form-control form-control-sm" title="Module Code" tabindex="7" autocomplete="on" (focusout)="getAssemblyDataByCode(assemblyObj.moduleCode, 'module')" [(ngModel)]="assemblyObj.moduleCode" appSelectedInput />
                </div>
              </div>
              <div class="col-6">
                <input type="text" name="txt_moduleName" id="txt_moduleName" class="form-control form-control-sm" title="Module" tabindex="8" autocomplete="on" [(ngModel)]="assemblyObj.moduleName" appSelectedInput />
              </div>
            </div>


            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_epCode" class="fs-12 mb-0 text400">
                  Eqp. Packg
                  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_epCode" id="txt_epCode" class="form-control form-control-sm" title="Equipment Package Code" tabindex="9" autocomplete="on" (focusout)="getAssemblyDataByCode(assemblyObj.epCode, 'ep')" [(ngModel)]="assemblyObj.epCode" appSelectedInput />
                </div>
              </div>
              <div class="col-6">
                <input type="text" name="txt_epName" id="txt_epName" class="form-control form-control-sm" title="Equipment Package" tabindex="10" autocomplete="on" [(ngModel)]="assemblyObj.epName" appSelectedInput />
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_loc1" class="fs-12 mb-0 text400">
                  Location 1
                </label>
              </div>
              <div class="col-9">
                <input type="text" name="txt_loc1" id="txt_loc1" class="form-control form-control-sm" title="Location 1" tabindex="11" autocomplete="on" [(ngModel)]="assemblyObj.location1" appSelectedInput />
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_loc2" class="fs-12 mb-0 text400">
                  Location 2
                </label>
              </div>
              <div class="col-9">
                <input type="text" name="txt_loc2" id="txt_loc2" class="form-control form-control-sm" title="Location 2" tabindex="12" autocomplete="on" [(ngModel)]="assemblyObj.location2" appSelectedInput />
              </div>
            </div>



            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_ref1" class="fs-12 mb-0 text400">
                  Cust Ref 1
                </label>
              </div>
              <div class="col-9">
                <input type="text" name="txt_ref1" id="txt_ref1" class="form-control form-control-sm" title="Cust Ref 1" tabindex="13" autocomplete="on" [(ngModel)]="assemblyObj.custRef1" appSelectedInput />
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_ref2" class="fs-12 mb-0 text400">
                  Cust Ref 2
                </label>
              </div>
              <div class="col-9">
                <input type="text" name="txt_ref2" id="txt_ref2" class="form-control form-control-sm" title="Cust Ref 2" tabindex="14" autocomplete="on" [(ngModel)]="assemblyObj.custRef2" appSelectedInput />
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_catInt" class="fs-12 mb-0 text400">
                  Cat Int
                </label>
              </div>
              <div class="col-9">
                <input type="text" name="txt_catInt" id="txt_catInt" class="form-control form-control-sm" title="Cat Int" tabindex="15" autocomplete="on" [(ngModel)]="assemblyObj.catInt" appTrimLeft />
              </div>
            </div>


            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_catCust" class="fs-12 mb-0 text400">
                  Cat Cust
                </label>
              </div>
              <div class="col-9">
                <input type="text" name="txt_catCust" id="txt_catCust" class="form-control form-control-sm" title="Cat Cust" tabindex="16" autocomplete="on" [(ngModel)]="assemblyObj.catCust" appTrimLeft />
              </div>
            </div>


            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_mediaCode" class="fs-12 mb-0 text400">
                  Media
                  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_mediaCode" id="txt_mediaCode" class="form-control form-control-sm" title="Media Code" tabindex="17" autocomplete="on" (focusout)="getAssemblyDataByCode(assemblyObj.mediaCode, 'media')" [(ngModel)]="assemblyObj.mediaCode" appSelectedInput />
                </div>
              </div>

              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_media" name="slc_media" title="Media" tabindex="18" (change)="codeById(assemblyObj.mediaId,'media')" [(ngModel)]="assemblyObj.mediaId">
                  <option value="0">Choose</option>
                  <option value="{{m.id}}" *ngFor="let m of assemblyObj.mediaObj">{{m.name}}</option>
                </select>
              </div>

            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_serviceCode" class="fs-12 mb-0 text400">
                  Service
                  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-2">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_serviceCode" id="txt_serviceCode" class="form-control form-control-sm" title="Service Code" (focusout)="getAssemblyDataByCode(assemblyObj.serviceCode, 'service')" tabindex="19" autocomplete="on" [(ngModel)]="assemblyObj.serviceCode" appSelectedInput />
                </div>
              </div>
              <div class="col-7">
                <select class="form-control form-control-sm select2" id="slc_service" name="slc_service" title="Service" tabindex="20" (change)="codeById(assemblyObj.serviceId,'service')" [(ngModel)]="assemblyObj.serviceId">
                  <option value="0">Choose</option>
                  <option value="{{s.id}}" *ngFor="let s of assemblyObj.serviceObj">{{s.name}}</option>
                </select>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_installDate" class="fs-12 mb-0 text400">
                  Install Date
                </label>
              </div>
              <div class="col-4">
                <input type="date" max="{{assemblyObj._currentDate}}" name="txt_installDate" id="txt_installDate" class="form-control form-control-sm" (change)="changeDateByMonth(assemblyObj.replFreq, 'replFreq')" title="Installation Date" tabindex="21" autocomplete="on" [(ngModel)]="assemblyObj.installDate" />
              </div>
              <div class="col-5 d-flex align-items-center">
                <input type="checkbox" name="chb_calcByInstallDate" id="chb_calcByInstallDate" title="Calculate Repl. Date By InstallDate" (change)="changeDateByMonth(assemblyObj.replFreq, 'replFreq')" tabindex="21" [(ngModel)]="assemblyObj.calcByInstallDateOpe" />
                <label for="chb_calcByInstallDate" style="margin-bottom: -1px; margin-left: 5px;" class="fs-12 mb-0 text400">
                  Repl. Date By Install Date
                </label>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_sysPress" class="fs-12 mb-0 text400">
                  Sys Press
                </label>
              </div>
              <div class="col-5">
                <input type="number" name="txt_sysPress" id="txt_sysPress" class="form-control form-control-sm" title="Sys Press" tabindex="22" autocomplete="on" [(ngModel)]="assemblyObj.sysPress" appTrimLeft />
              </div>
              <div class="col-2 d-flex align-items-center">
                <input type="radio" id="bar" name="sysPressType" [(ngModel)]="assemblyObj.sysPressType" [value]="1" tabindex="23">
                <label for="bar" class="ml-1 mb-0"> BAR</label><br>
              </div>
              <div class="col-2 d-flex align-items-center">
                <input type="radio" id="psi" name="sysPressType" [(ngModel)]="assemblyObj.sysPressType" [value]="2" tabindex="24">
                <label for="psi" class="ml-1 mb-0"> PSI</label><br>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_custAttributeCode" class="fs-12 mb-0 text400">
                  Cust Attr
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_custAttributeCode" id="txt_custAttributeCode" class="form-control form-control-sm" title="Cust Attribute Code" tabindex="25" autocomplete="on" (focusout)="getAssemblyDataByCode(assemblyObj.custAttributeCode, 'custAttribute')" [(ngModel)]="assemblyObj.custAttributeCode" appSelectedInput />
                </div>
              </div>

              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_custAttribute" name="slc_custAttribute" title="Customer Attribute" tabindex="26" (change)="codeById(assemblyObj.custAttributeId,'custAttribute')" [(ngModel)]="assemblyObj.custAttributeId">
                  <option value="0">Choose</option>
                  <option value="{{c.id}}" *ngFor="let c of assemblyObj.custAttributeObj">{{c.name}}</option>
                </select>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_consequenceCode" class="fs-12 mb-0 text400">
                  Consequence
                </label>
              </div>
              <div class="col-2">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_consequenceCode" id="txt_consequenceCode" class="form-control form-control-sm" title="Consequence Code" tabindex="27" autocomplete="on" (focusout)="getAssemblyDataByCode(assemblyObj.consequenceCode, 'consequence')" [(ngModel)]="assemblyObj.consequenceCode" appSelectedInput />
                </div>
              </div>
              <div class="col-7">
                <select class="form-control form-control-sm select2" id="slc_consequence" name="slc_consequence" title="Consequence" tabindex="28" (change)="codeById(assemblyObj.consequenceId,'consequence')" [(ngModel)]="assemblyObj.consequenceId">
                  <option value="0">Choose</option>
                  <option value="{{c.id}}" *ngFor="let c of assemblyObj.consequenceObj">{{c.name}}</option>
                </select>
              </div>
            </div>


            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_probabilityCode" class="fs-12 mb-0 text400">
                  Probability
                </label>
              </div>
              <div class="col-2">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_probabilityCode" id="txt_probabilityCode" class="form-control form-control-sm" title="Probability Code" tabindex="29" autocomplete="on" (focusout)="getAssemblyDataByCode(assemblyObj.probabilityCode, 'probability')" [(ngModel)]="assemblyObj.probabilityCode" appSelectedInput />
                </div>
              </div>
              <div class="col-7">
                <select class="form-control form-control-sm select2" id="slc_probability" name="slc_probability" title="Probability" tabindex="30" (change)="codeById(assemblyObj.probabilityId,'probability')" [(ngModel)]="assemblyObj.probabilityId">
                  <option value="0">Choose</option>
                  <option value="{{p.id}}" *ngFor="let p of assemblyObj.probabilityObj">{{p.name}}</option>
                </select>
              </div>
            </div>







          </div>
          <!--LOCATION & ROLE END-->
          <!--ASSEMBLY-->
          <div class="col-4" [ngClass]="reinspectionOpe ? 'pointer-event-disabled' : '' ">




            <div class="row">
              <div class="col-7 mt-1">
                <div>
                  <b>Assembly</b>
                </div>
                <span class="text-muted d-block fs-12">Enter Assembly Information</span>
              </div>
              <div class="col-12">
                <hr class="border-dashed border-bottom-0 mt-1 mb-2" />
              </div>
            </div>




            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_locTagNo" class="fs-12 mb-0 text400">
                  Loc Tag No
                  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-9">
                <input type="text" name="txt_locTagNo" id="txt_locTagNo" class="form-control form-control-sm" title="Loc Tag No" tabindex="31" autocomplete="on" [(ngModel)]="assemblyObj.locTagNo" appTrimLeft />
              </div>
            </div>


            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_serialNo" class="fs-12 mb-0 text400">
                  Serial No
                </label>
              </div>
              <div class="col-9">
                <input type="text" name="txt_serialNo" id="txt_serialNo" class="form-control form-control-sm" title="Serial No" tabindex="32" autocomplete="on" [(ngModel)]="assemblyObj.serialNo" appTrimLeft />
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_specCode" class="fs-12 mb-0 text400">
                  Spec Code
                  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-8">
                <input type="text" name="txt_specCode" id="txt_specCode" class="form-control form-control-sm" title="Spec Code" tabindex="33" autocomplete="on" [(ngModel)]="assemblyObj.specCode" (focusout)="getSpeccodeInfo(assemblyObj.specCode)" appTrimLeft />
              </div>
              <div class="col-1 p-0">
                <button class="btn btn-sm btn-falcon-default py-1 px-2" (click)="getSpeccodePopup()"><i class="fas fa-magic"></i></button>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_specCodeDesc" class="fs-12 mb-0 text400 text-nowrap">
                  Description
                  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-9">
                <textarea name="txt_specCodeDesc" id="txt_specCodeDesc" class="form-control form-control-sm" rows="4" title="Spec Code Description" tabindex="34" autocomplete="on" [(ngModel)]="assemblyObj.specCodeDesc" appTrimLeft></textarea>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_hoseType" class="fs-12 mb-0 text400">
                  Hose Type
                </label>
              </div>
              <div class="col-9">
                <input type="text" name="txt_hoseType" id="txt_hoseType" class="form-control form-control-sm" title="Hose Type" tabindex="35" autocomplete="on" [(ngModel)]="assemblyObj.hoseType" appTrimLeft />
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_boreSize" class="fs-12 mb-0 text400">
                  Bore Size
                </label>
              </div>
              <div class="col-3">
                <input type="text" name="txt_boreSize" id="txt_boreSize" class="form-control form-control-sm" title="Bore Size" tabindex="36" autocomplete="on" [(ngModel)]="assemblyObj.boreSize" />
              </div>


              <div class="col-2 text-right">
                <label for="txt_boreLength" class="fs-12 mb-0 text400">
                  Length
                </label>
              </div>
              <div class="col-4">
                <input type="number" name="txt_boreLength" id="txt_boreLength" class="form-control form-control-sm" title="Length" tabindex="37" autocomplete="on" [(ngModel)]="assemblyObj.boreLength" appTrimLeft />
              </div>
            </div>


            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_orientation" class="fs-12 mb-0 text400">
                  Orientation
                </label>
              </div>
              <div class="col-3">
                <input type="number" name="txt_orientation" id="txt_orientation" class="form-control form-control-sm" title="Orientation" tabindex="38" autocomplete="on" [(ngModel)]="assemblyObj.orientation" appTrimLeft />
              </div>


              <div class="col-2 text-right">
                <label for="slc_method" class="fs-12 mb-0 text400">
                  Method
                </label>
              </div>
              <div class="col-4">
                <select class="form-control form-control-sm select2" id="slc_method" name="slc_method" title="Probability" tabindex="39" [(ngModel)]="assemblyObj.methodId">
                  <option value="0">Choose</option>
                  <option value="{{m.id}}" *ngFor="let m of assemblyObj.methodObj">{{m.name}}</option>
                </select>
              </div>
            </div>




            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_minTemp" class="fs-12 mb-0 text400">
                  Min °C
                </label>
              </div>
              <div class="col-3">
                <input type="number" name="txt_minTemp" id="txt_minTemp" class="form-control form-control-sm" title="Min Temp" tabindex="40" autocomplete="on" [(ngModel)]="assemblyObj.minTemp" appTrimLeft />
              </div>


              <div class="col-2 text-right">
                <label for="txt_maxTemp" class="fs-12 mb-0 text400">
                  Max °C
                </label>
              </div>
              <div class="col-4">
                <input type="number" name="txt_maxTemp" id="txt_maxTemp" class="form-control form-control-sm" title="Max Temp" tabindex="41" autocomplete="on" [(ngModel)]="assemblyObj.maxTemp" appTrimLeft />
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_maxWP" class="fs-12 mb-0 text400">
                  Max WP
                </label>
              </div>
              <div class="col-5">
                <input type="number" name="txt_maxWP" id="txt_maxWP" class="form-control form-control-sm" title="Max WP" tabindex="42" autocomplete="on" [(ngModel)]="assemblyObj.maxWP" appTrimLeft />
              </div>
              <div class="col-2 d-flex align-items-center">
                <input type="radio" id="bar_" name="maxWPType" [value]="1" [(ngModel)]="assemblyObj.maxWPType" tabindex="43">
                <label for="bar_" class="mb-0 ml-1"> BAR</label><br>
              </div>
              <div class="col-2 d-flex align-items-center">
                <input type="radio" id="psi_" name="maxWPType" [value]="2" [(ngModel)]="assemblyObj.maxWPType" tabindex="44">
                <label for="psi_" class="mb-0 ml-1"> PSI</label><br>
              </div>
            </div>


            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_supplierCode" class="fs-12 mb-0 text400">
                  Supplier
                  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_supplierCode" id="txt_supplierCode" class="form-control form-control-sm" title="Supplier Code" (focusout)="getAssemblyDataByCode(assemblyObj.supplierCode, 'supplier')" tabindex="45" autocomplete="on" [(ngModel)]="assemblyObj.supplierCode" appSelectedInput />
                </div>
              </div>

              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_supplier" name="slc_supplier" title="Supplier" tabindex="46" (change)="codeById(assemblyObj.supplierId,'supplier')" [(ngModel)]="assemblyObj.supplierId">
                  <option value="{{s.id}}" *ngFor="let s of assemblyObj.supplierObj">{{s.name}}</option>
                </select>
              </div>
            </div>




            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_orderNo" class="fs-12 mb-0 text400">
                  Sales Order
                </label>
              </div>
              <div class="col-3">
                <input type="text" name="txt_orderNo" id="txt_orderNo" class="form-control form-control-sm" title="Sales Order" tabindex="47" autocomplete="on" [(ngModel)]="assemblyObj.salesOrder" appTrimLeft />
              </div>


              <div class="col-2 text-right">
                <label for="txt_expDate" class="fs-12 mb-0 text400">
                  Exp Date
                </label>
              </div>
              <div class="col-4">
                <input type="date" name="txt_expDate" id="txt_expDate" class="form-control form-control-sm" title="Expire Date" tabindex="48" autocomplete="on" [(ngModel)]="assemblyObj.expDate" appTrimLeft />
              </div>
            </div>




            <div class="row mb-1">


              <div class="col-3 text-right">
                <label for="txt_class" class="fs-12 mb-0 text400">
                  Class
                </label>
              </div>
              <div class="col-3">
                <input type="number" min="0" max="5" name="txt_class" id="txt_class" class="form-control form-control-sm" title="Class" tabindex="78" autocomplete="on" [(ngModel)]="assemblyObj._class" appTrimLeft />
              </div>


              <div class="col-2 text-right">
                <label for="txt_poNo" class="fs-12 mb-0 text400">
                  Cust PO
                </label>
              </div>
              <div class="col-4">
                <input type="text" name="txt_poNo" id="txt_poNo" class="form-control form-control-sm" title="Cust PO" tabindex="49" autocomplete="on" [(ngModel)]="assemblyObj.custPO" appTrimLeft />
              </div>


            </div>



            <div class="row mb-2">


              <div class="col-3 text-right">
                <label for="txt_cureDate" class="fs-12 mb-0 text400">
                  Cure Date
                </label>
              </div>
              <div class="col-3">
                <input type="date" name="txt_cureDate" id="txt_cureDate" class="form-control form-control-sm" title="Cure Date" tabindex="50" autocomplete="on" [(ngModel)]="assemblyObj.cureDate" appTrimLeft />
              </div>


              <div class="col-2 text-right">
                <label for="txt_manuDate" class="fs-12 mb-0 text400">
                  Man Date
                </label>
              </div>
              <div class="col-4">
                <input type="date" name="txt_manuDate" id="txt_manuDate" class="form-control form-control-sm" (change)="changeDateByMonth(assemblyObj.replFreq, 'replFreq')" title="Manu Date" tabindex="51" autocomplete="on" [(ngModel)]="assemblyObj.manuDate" appTrimLeft />
              </div>



            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_weltNote" class="fs-12 mb-0 text400">
                  Welt Note
                </label>
              </div>
              <div class="col-9">
                <textarea name="txt_weltNote" id="txt_weltNote" class="form-control form-control-sm" rows="4" title="HydrasWeltun Note" tabindex="53" autocomplete="on" [(ngModel)]="assemblyObj.note"></textarea>
              </div>
            </div>


          </div>
          <!--ASSEMBLY END-->
          <!--INSPECTION-->
          <div class="col-4">




            <div class="row" [ngClass]="reinspectionOpe ? 'pointer-event-disabled' : '' ">
              <div class="col-7 mt-1">
                <div>
                  <b>Inspection</b>
                </div>
                <span class="text-muted d-block fs-12">Enter Inspection Information</span>
              </div>
              <div class="col-12">
                <hr class="border-dashed border-bottom-0 mt-1 mb-2" />
              </div>
            </div>




            <div class="row mb-1" [ngClass]="reinspectionOpe ? 'pointer-event-disabled' : '' ">
              <div class="col-3 text-right">
                <label for="txt_refCode" class="fs-12 mb-0 text400">
                  Ref
                  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-3">
                <input type="text" name="txt_refCode" id="txt_refCode" class="form-control form-control-sm" title="Ref Code" tabindex="54" autocomplete="on" (focusout)="getAssemblyDataByCode(assemblyObj.refCode, 'ref')" [(ngModel)]="assemblyObj.refCode" appSelectedInput />
              </div>
              <div class="col-6">
                <input type="text" name="txt_refName" id="txt_refName" class="form-control form-control-sm" title="Ref" tabindex="55" autocomplete="on" [(ngModel)]="assemblyObj.refName" appSelectedInput />
              </div>
            </div>


            <div class="row mb-1" [ngClass]="reinspectionOpe ? 'pointer-event-disabled' : '' ">
              <div class="col-3 text-right">
                <label for="txt_startDate" class="fs-12 mb-0 text400">
                  Start Date
                </label>
              </div>
              <div class="col-4">
                <input type="date" name="txt_startDate" id="txt_startDate" class="form-control form-control-sm" title="Start Date" tabindex="56" autocomplete="on" [(ngModel)]="assemblyObj.startDate" appTrimLeft />
              </div>


              <div class="col-1 text-right" [ngClass]="reinspectionOpe ? 'pointer-event-disabled' : '' ">
                <label for="slc_status" class="fs-12 mb-0 text400">
                  Status
                </label>
              </div>
              <div class="col-4">
                <select class="form-control form-control-sm select2" id="slc_status" name="slc_status" title="Probability" tabindex="57" [(ngModel)]="assemblyObj.statusId">
                  <option value="0">Choose</option>
                  <option value="{{s.id}}" *ngFor="let s of assemblyObj.statusObj">{{s.name}}</option>
                </select>
              </div>
            </div>


            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="slc_type" class="fs-12 mb-0 text400">
                  Type
                  <span class="text-danger">*</span>
                </label>
              </div>

              <div class="col-9">
                <select class="form-control form-control-sm select2" id="slc_type" name="slc_type" title="Service" tabindex="58" [(ngModel)]="assemblyObj.typeId">
                  <option value="0">Choose</option>
                  <option value="{{t.id}}" *ngFor="let t of assemblyObj.typeObj">{{t.name}}</option>
                </select>
              </div>
            </div>



            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_date" class="fs-12 mb-0 text400">
                  Date  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-4">
                <input type="date" max="{{assemblyObj._currentDate}}" name="txt_date" id="txt_date" (change)="changeDateByMonth(assemblyObj.inspFreq, 'inspFreq')" class="form-control form-control-sm" title="Date" tabindex="59" autocomplete="on" [(ngModel)]="assemblyObj._date" appTrimLeft />
              </div>
            </div>



            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_inspectorCode" class="fs-12 mb-0 text400">
                  Inspector
                  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_inspectorCode" id="txt_inspectorCode" class="form-control form-control-sm" title="Inspector Code" tabindex="60" autocomplete="on" (focusout)="getAssemblyDataByCode(assemblyObj.inspectorCode, 'inspector')" [(ngModel)]="assemblyObj.inspectorCode" appSelectedInput />
                </div>
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_inspector" name="slc_inspector" title="Inspector" tabindex="61" (change)="codeById(assemblyObj.inspectorId,'inspector')" [(ngModel)]="assemblyObj.inspectorId">
                  <option value="0">Choose</option>
                  <option value="{{i.id}}" *ngFor="let i of assemblyObj.inspectorObj">{{i.name}}</option>
                </select>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_conditionCode" class="fs-12 mb-0 text400">
                  Condition
                  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_conditionCode" id="txt_conditionCode" class="form-control form-control-sm" title="Condition Code" tabindex="62" autocomplete="on" (focusout)="getAssemblyDataByCode(assemblyObj.conditionCode, 'condition')" [(ngModel)]="assemblyObj.conditionCode" appSelectedInput />
                </div>
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_condition" name="slc_condition" title="Condition" tabindex="63" (change)="codeById(assemblyObj.conditionId,'condition')" [(ngModel)]="assemblyObj.conditionId">
                  <option value="0">Choose</option>
                  <option value="{{c.id}}" *ngFor="let c of assemblyObj.conditionObj">{{c.name}}</option>
                </select>
              </div>
            </div>



            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_reasonCode1" class="fs-12 mb-0 text400">
                  Reason 1
                  <span class="text-danger" *ngIf="assemblyObj.conditionId==9">*</span>
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_reasonCode1" id="txt_reasonCode1" class="form-control form-control-sm" title="Reason 1 Code" tabindex="64" autocomplete="on" (focusout)="getAssemblyDataByCode(assemblyObj.reasonCode1, 'reason1')" [(ngModel)]="assemblyObj.reasonCode1" appSelectedInput />
                </div>
              </div>

              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_reason1" name="slc_reason1" title="Reason 1" tabindex="65" (change)="codeById(assemblyObj.reasonId1,'reason1')" [(ngModel)]="assemblyObj.reasonId1">
                  <option value="0">Choose</option>
                  <option value="{{r.id}}" *ngFor="let r of assemblyObj.reasonObj">{{r.name}}</option>
                </select>
              </div>
            </div>


            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_reasonCode2" class="fs-12 mb-0 text400">
                  Reason 2
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_reasonCode2" id="txt_reasonCode2" class="form-control form-control-sm" title="Reason 2 Code" tabindex="66" autocomplete="on" (focusout)="getAssemblyDataByCode(assemblyObj.reasonCode2, 'reason2')" [(ngModel)]="assemblyObj.reasonCode2" appSelectedInput />
                </div>
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_reason2" name="slc_reason2" title="Reason 2" tabindex="67" (change)="codeById(assemblyObj.reasonId2,'reason2')" [(ngModel)]="assemblyObj.reasonId2">
                  <option value="0">Choose</option>
                  <option value="{{r.id}}" *ngFor="let r of assemblyObj.reasonObj">{{r.name}}</option>
                </select>
              </div>
            </div>


            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_reasonCode3" class="fs-12 mb-0 text400">
                  Reason 3
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_reasonCode3" id="txt_reasonCode3" class="form-control form-control-sm" title="Reason 3 Code" tabindex="68" autocomplete="on" (focusout)="getAssemblyDataByCode(assemblyObj.reasonCode3, 'reason3')" [(ngModel)]="assemblyObj.reasonCode3" appSelectedInput />
                </div>
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_reason3" name="slc_reason3" title="Reason 3" tabindex="69" (change)="codeById(assemblyObj.reasonId3,'reason3')" [(ngModel)]="assemblyObj.reasonId3">
                  <option value="0">Choose</option>
                  <option value="{{r.id}}" *ngFor="let r of assemblyObj.reasonObj">{{r.name}}</option>
                </select>
              </div>
            </div>


            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_reasonCode4" class="fs-12 mb-0 text400">
                  Reason 4
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_reasonCode4" id="txt_reasonCode4" class="form-control form-control-sm" title="Reason 4 Code" tabindex="70" autocomplete="on" (focusout)="getAssemblyDataByCode(assemblyObj.reasonCode4, 'reason4')" [(ngModel)]="assemblyObj.reasonCode4" appSelectedInput />
                </div>
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_reason4" name="slc_reason4" title="Reason 4" tabindex="71" (change)="codeById(assemblyObj.reasonId4,'reason4')" [(ngModel)]="assemblyObj.reasonId4">
                  <option value="0">Choose</option>
                  <option value="{{r.id}}" *ngFor="let r of assemblyObj.reasonObj">{{r.name}}</option>
                </select>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_reasonCode5" class="fs-12 mb-0 text400">
                  Reason 5
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_reasonCode5" id="txt_reasonCode5" class="form-control form-control-sm" title="Reason 5 Code" tabindex="72" autocomplete="on" (focusout)="getAssemblyDataByCode(assemblyObj.reasonCode5, 'reason5')" [(ngModel)]="assemblyObj.reasonCode5" appSelectedInput />
                </div>
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_reason5" name="slc_reason5" title="Reason 5" tabindex="73" (change)="codeById(assemblyObj.reasonId5,'reason5')" [(ngModel)]="assemblyObj.reasonId5">
                  <option value="0">Choose</option>
                  <option value="{{r.id}}" *ngFor="let r of assemblyObj.reasonObj">{{r.name}}</option>
                </select>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_recommendation" class="fs-12 mb-0 text400">
                  Recommendation
                </label>
              </div>
              <div class="col-9">
                <input type="text" name="txt_recommendation" id="txt_recommendation" class="form-control form-control-sm" title="Recommendation" tabindex="74" autocomplete="on" [(ngModel)]="assemblyObj.recommendation" appTrimLeft />
              </div>
            </div>



            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_comment" class="fs-12 mb-0 text400">
                  Cust. Comment
                </label>
              </div>
              <div class="col-9">
                <textarea name="txt_comment" id="txt_comment" class="form-control form-control-sm" rows="2" title="Customer Comment" tabindex="75" autocomplete="on" [(ngModel)]="assemblyObj.comment"></textarea>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_scrappedDate" class="fs-12 mb-0 text400">
                  Scrapped
                  <span class="text-danger" *ngIf="assemblyObj.conditionId==9">*</span>
                </label>
              </div>
              <div class="col-4">
                <input type="date" max="{{assemblyObj._currentDate}}" class="form-control form-control-sm" name="txt_scrappedDate" id="txt_scrappedDate" title="Scrapped Date" tabindex="76" autocomplete="on" [(ngModel)]="assemblyObj.scrappedDate" appTrimLeft />
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_authBy" class="fs-12 mb-0 text400">
                  Auth By
                </label>
              </div>
              <div class="col-9">
                <input type="text" name="txt_authBy" id="txt_authBy" class="form-control form-control-sm" title="Auth By" tabindex="77" autocomplete="on" [(ngModel)]="assemblyObj.authBy" appTrimLeft />
              </div>
            </div>






            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_inspFreq" class="fs-12 mb-0 text400">
                  Insp. Freq
                </label>
              </div>
              <div class="col-3">
                <input type="number" disabled name="txt_inspFreq" id="txt_inspFreq" class="form-control form-control-sm" title="Class" tabindex="80" autocomplete="on" (keyup)="changeDateByMonth(assemblyObj.inspFreq, 'inspFreq')" [(ngModel)]="assemblyObj.inspFreq" />
              </div>


              <div class="col-2 text-right">
                <label for="txt_nextInspectionDate" class="fs-12 mb-0 text400">
                  Next Insp
                </label>
              </div>
              <div class="col-4">
                <input type="date" min="{{assemblyObj._currentDate}}" disabled class="form-control form-control-sm" name="txt_nextInspectionDate" id="txt_nextInspectionDate" title="Next Inspection Date" tabindex="81" autocomplete="on" [(ngModel)]="assemblyObj.nextInspectionDate" />
              </div>
            </div>



            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_replFreq" class="fs-12 mb-0 text400">
                  Repl. Freq
                </label>
              </div>
              <div class="col-3">
                <input type="number" disabled name="txt_replFreq" id="txt_replFreq" class="form-control form-control-sm" title="Class" tabindex="82" autocomplete="on" (keyup)="changeDateByMonth(assemblyObj.replFreq, 'replFreq')" [(ngModel)]="assemblyObj.replFreq" />
              </div>


              <div class="col-2 text-right">
                <label for="txt_replDate" class="fs-12 mb-0 text400">
                  Repl Date
                </label>
              </div>
              <div class="col-4">
                <input type="date" class="form-control form-control-sm" disabled name="txt_replDate" id="txt_nextInspectionDate" title="txt_replDate Inspection Date" tabindex="83" autocomplete="on" [(ngModel)]="assemblyObj.replDate" />
              </div>
            </div>



          </div>
          <!--INSPECTION END-->
        </div>






      </div>
      <div class="modal-footer">
        <div class="mr-5">
          <label class="text-danger" *ngIf="assemblyObj.customerCode=='' || assemblyObj.assetCode=='' || assemblyObj.deckCode=='' || assemblyObj.moduleCode=='' || assemblyObj.epCode=='' || assemblyObj.mediaCode=='' || assemblyObj.serviceId==0 || assemblyObj.locTagNo=='' || assemblyObj.specCode=='' || assemblyObj.specCodeDesc=='' || assemblyObj.supplierCode=='' || assemblyObj.refCode=='' || assemblyObj.typeId==0 || !assemblyObj._date || assemblyObj.inspectorId==0 || assemblyObj.conditionId==0 || (assemblyObj.conditionId==9 && (assemblyObj.reasonCode1=='' || !assemblyObj.scrappedDate))">
            Please fill out all required fields. Fields marked with * are mandatory.
          </label>
        </div>
        <div class="mr-3" *ngIf="assemblyObj.refId!=0">
          <button class="btn btn-falcon-default btn-sm mr-1" type="button" id="btn_PREV" (click)="next(assemblyObj.id,'PREV')">< Prev</button>
          <button class="btn btn-falcon-default btn-sm ml-1" type="button" id="btn_NEXT" (click)="next(assemblyObj.id,'NEXT')">Next ></button>
        </div>



        <button class="btn btn-falcon-default btn-sm" type="button" (click)="modalAssemblyClose()">Close</button>
        <button class="btn btn-primary btn-sm" id="btn_save" type="button" [disabled]="assemblyObj.customerCode=='' || assemblyObj.assetCode=='' || assemblyObj.deckCode=='' || assemblyObj.moduleCode=='' || assemblyObj.epCode=='' || assemblyObj.mediaCode=='' || assemblyObj.serviceId==0 || assemblyObj.locTagNo=='' || assemblyObj.specCode=='' || assemblyObj.specCodeDesc=='' || assemblyObj.supplierCode=='' || assemblyObj.refCode=='' || assemblyObj.typeId==0 || !assemblyObj._date || assemblyObj.inspectorId==0 || assemblyObj.conditionId==0 || (assemblyObj.conditionId==9 && (assemblyObj.reasonCode1=='' || !assemblyObj.scrappedDate))" (click)="saveAssembly(1)">
          Save & Close
        </button>
        <button *ngIf="assemblyObj.refId!=0" class="btn btn-success btn-sm" id="btn_save_next" type="button" [disabled]="assemblyObj.customerCode=='' || assemblyObj.assetCode=='' || assemblyObj.deckCode=='' || assemblyObj.moduleCode=='' || assemblyObj.epCode=='' || assemblyObj.mediaCode=='' || assemblyObj.serviceId==0 || assemblyObj.locTagNo=='' || assemblyObj.specCode=='' || assemblyObj.specCodeDesc=='' || assemblyObj.supplierCode=='' || assemblyObj.refCode=='' || assemblyObj.typeId==0 || !assemblyObj._date || assemblyObj.inspectorId==0 || assemblyObj.conditionId==0 || (assemblyObj.conditionId==9 && (assemblyObj.reasonCode1=='' || !assemblyObj.scrappedDate))" (click)="saveAssembly(2)">
          Save & Next
        </button>
      </div>
    </div>
  </div>
</div>
<!---->
<!-- Modal Batch inspection-->
<div class="modal fade" id="batchInspectionModal" tabindex="-1" role="dialog" aria-labelledby="batchInspectionModal" data-backdrop="static" data-keyboard="false"
     aria-hidden="true" (keydown.esc)="modalBatchInspectionClose()">
  <div class="modal-dialog modal-width-650px ui-draggable" role="document">
    <div class="modal-content ">
      <div class="modal-header">
        <h5 class="modal-title">{{modalTitleBatchInspection}}</h5>
        <button class="close" type="button" aria-label="Close" (click)="modalBatchInspectionClose()">
          <span class="font-weight-light" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body " id="batchInspectionBody" style="padding: 1rem 2rem !important;">
        <div class="row">
          <div class="col-12">
            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_refCode" class="fs-12 mb-0 text400">
                  Ref
                  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-3">
                <input type="text" name="txt_refCode" id="txt_brefCode" class="form-control form-control-sm" title="Ref Code" tabindex="54" autocomplete="on" (focusout)="getAssemblyDataByCode(batchInspectionObj.refCode, 'bref')" [(ngModel)]="batchInspectionObj.refCode" appSelectedInput />
              </div>
              <div class="col-6">
                <input type="text" name="txt_refName" id="txt_brefName" class="form-control form-control-sm" title="Ref" tabindex="55" autocomplete="on" [(ngModel)]="batchInspectionObj.refName" appSelectedInput />
              </div>
            </div>


            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="slc_type" class="fs-12 mb-0 text400">
                  Type
                  <span class="text-danger">*</span>
                </label>
              </div>

              <div class="col-9">
                <select class="form-control form-control-sm select2" id="slc_btype" name="slc_type" title="Service" tabindex="58" [(ngModel)]="batchInspectionObj.typeId">
                  <option value="0">Choose</option>
                  <option value="{{t.id}}" *ngFor="let t of batchInspectionObj.typeObj">{{t.name}}</option>
                </select>
              </div>
            </div>



            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_date" class="fs-12 mb-0 text400">
                  Date  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-4">
                <input type="date" max="{{batchInspectionObj._currentDate}}" name="txt_date" id="txt_bdate" (change)="changeDateByMonth(batchInspectionObj.inspFreq, 'inspFreq')" class="form-control form-control-sm" title="Date" tabindex="59" autocomplete="on" [(ngModel)]="batchInspectionObj._date" appTrimLeft />
              </div>
            </div>



            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_inspectorCode" class="fs-12 mb-0 text400">
                  Inspector
                  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_inspectorCode" id="txt_binspectorCode" class="form-control form-control-sm" title="Inspector Code" tabindex="60" autocomplete="on" (focusout)="getAssemblyDataByCode(batchInspectionObj.inspectorCode, 'binspector')" [(ngModel)]="batchInspectionObj.inspectorCode" appSelectedInput />
                </div>
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_binspector" name="slc_inspector" title="Inspector" tabindex="61" (change)="codeById(batchInspectionObj.inspectorId,'binspector')" [(ngModel)]="batchInspectionObj.inspectorId">
                  <option value="0">Choose</option>
                  <option value="{{i.id}}" *ngFor="let i of batchInspectionObj.inspectorObj">{{i.name}}</option>
                </select>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_conditionCode" class="fs-12 mb-0 text400">
                  Condition
                  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_conditionCode" id="txt_bconditionCode" class="form-control form-control-sm" title="Condition Code" tabindex="62" autocomplete="on" (focusout)="getAssemblyDataByCode(batchInspectionObj.conditionCode, 'bcondition')" [(ngModel)]="batchInspectionObj.conditionCode" appSelectedInput />
                </div>
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_bcondition" name="slc_condition" title="Condition" tabindex="63" (change)="codeById(batchInspectionObj.conditionId,'bcondition')" [(ngModel)]="batchInspectionObj.conditionId">
                  <option value="0">Choose</option>
                  <option value="{{c.id}}" *ngFor="let c of batchInspectionObj.conditionObj">{{c.name}}</option>
                </select>
              </div>
            </div>



            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_reasonCode1" class="fs-12 mb-0 text400">
                  Reason 1
                  <span class="text-danger" *ngIf="batchInspectionObj.conditionId==9">*</span>
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_reasonCode1" id="txt_breasonCode1" class="form-control form-control-sm" title="Reason 1 Code" tabindex="64" autocomplete="on" (focusout)="getAssemblyDataByCode(batchInspectionObj.reasonCode1, 'breason1')" [(ngModel)]="batchInspectionObj.reasonCode1" appSelectedInput />
                </div>
              </div>

              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_breason1" name="slc_reason1" title="Reason 1" tabindex="65" (change)="codeById(batchInspectionObj.reasonId1,'breason1')" [(ngModel)]="batchInspectionObj.reasonId1">
                  <option value="0">Choose</option>
                  <option value="{{r.id}}" *ngFor="let r of batchInspectionObj.reasonObj">{{r.name}}</option>
                </select>
              </div>
            </div>


            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_reasonCode2" class="fs-12 mb-0 text400">
                  Reason 2
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_reasonCode2" id="txt_breasonCode2" class="form-control form-control-sm" title="Reason 2 Code" tabindex="66" autocomplete="on" (focusout)="getAssemblyDataByCode(batchInspectionObj.reasonCode2, 'breason2')" [(ngModel)]="batchInspectionObj.reasonCode2" appSelectedInput />
                </div>
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_breason2" name="slc_reason2" title="Reason 2" tabindex="67" (change)="codeById(batchInspectionObj.reasonId2,'breason2')" [(ngModel)]="batchInspectionObj.reasonId2">
                  <option value="0">Choose</option>
                  <option value="{{r.id}}" *ngFor="let r of batchInspectionObj.reasonObj">{{r.name}}</option>
                </select>
              </div>
            </div>


            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_reasonCode3" class="fs-12 mb-0 text400">
                  Reason 3
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_reasonCode3" id="txt_breasonCode3" class="form-control form-control-sm" title="Reason 3 Code" tabindex="68" autocomplete="on" (focusout)="getAssemblyDataByCode(batchInspectionObj.reasonCode3, 'breason3')" [(ngModel)]="batchInspectionObj.reasonCode3" appSelectedInput />
                </div>
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_breason3" name="slc_reason3" title="Reason 3" tabindex="69" (change)="codeById(batchInspectionObj.reasonId3,'breason3')" [(ngModel)]="batchInspectionObj.reasonId3">
                  <option value="0">Choose</option>
                  <option value="{{r.id}}" *ngFor="let r of batchInspectionObj.reasonObj">{{r.name}}</option>
                </select>
              </div>
            </div>


            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_reasonCode4" class="fs-12 mb-0 text400">
                  Reason 4
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_reasonCode4" id="txt_breasonCode4" class="form-control form-control-sm" title="Reason 4 Code" tabindex="70" autocomplete="on" (focusout)="getAssemblyDataByCode(batchInspectionObj.reasonCode4, 'breason4')" [(ngModel)]="batchInspectionObj.reasonCode4" appSelectedInput />
                </div>
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_breason4" name="slc_reason4" title="Reason 4" tabindex="71" (change)="codeById(batchInspectionObj.reasonId4,'breason4')" [(ngModel)]="batchInspectionObj.reasonId4">
                  <option value="0">Choose</option>
                  <option value="{{r.id}}" *ngFor="let r of batchInspectionObj.reasonObj">{{r.name}}</option>
                </select>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_reasonCode5" class="fs-12 mb-0 text400">
                  Reason 5
                </label>
              </div>
              <div class="col-3">
                <div class="input-group form-group mb-0 position-relative">
                  <span class="search-sign"><i class="fas fa-search"></i></span>
                  <input type="text" name="txt_reasonCode5" id="txt_breasonCode5" class="form-control form-control-sm" title="Reason 5 Code" tabindex="72" autocomplete="on" (focusout)="getAssemblyDataByCode(batchInspectionObj.reasonCode5, 'breason5')" [(ngModel)]="batchInspectionObj.reasonCode5" appSelectedInput />
                </div>
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_breason5" name="slc_reason5" title="Reason 5" tabindex="73" (change)="codeById(batchInspectionObj.reasonId5,'breason5')" [(ngModel)]="batchInspectionObj.reasonId5">
                  <option value="0">Choose</option>
                  <option value="{{r.id}}" *ngFor="let r of batchInspectionObj.reasonObj">{{r.name}}</option>
                </select>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_recommendation" class="fs-12 mb-0 text400">
                  Recommendation
                </label>
              </div>
              <div class="col-9">
                <input type="text" name="txt_recommendation" id="txt_brecommendation" class="form-control form-control-sm" title="Recommendation" tabindex="74" autocomplete="on" [(ngModel)]="batchInspectionObj.recommendation" appTrimLeft />
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_comment" class="fs-12 mb-0 text400">
                  Cust. Comment
                </label>
              </div>
              <div class="col-9">
                <textarea name="txt_comment" id="txt_bcomment" class="form-control form-control-sm" rows="2" title="Customer Comment" tabindex="75" autocomplete="on" [(ngModel)]="batchInspectionObj.comment"></textarea>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_scrappedDate" class="fs-12 mb-0 text400">
                  Scrapped
                  <span class="text-danger" *ngIf="batchInspectionObj.conditionId==9">*</span>
                </label>
              </div>
              <div class="col-4">
                <input type="date" class="form-control form-control-sm" name="txt_scrappedDate" id="txt_bscrappedDate" title="Scrapped Date" tabindex="76" autocomplete="on" [(ngModel)]="batchInspectionObj.scrappedDate" appTrimLeft />
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_authBy" class="fs-12 mb-0 text400">
                  Auth By
                </label>
              </div>
              <div class="col-9">
                <input type="text" name="txt_authBy" id="txt_bauthBy" class="form-control form-control-sm" title="Auth By" tabindex="77" autocomplete="on" [(ngModel)]="batchInspectionObj.authBy" appTrimLeft />
              </div>
            </div>
          </div>
        </div>






      </div>
      <div class="modal-footer">
        <div class="mr-3">
          <label class="text-danger fs-12" *ngIf="batchInspectionObj.refCode=='' || batchInspectionObj.typeId==0 || !batchInspectionObj._date || batchInspectionObj.inspectorId==0 || batchInspectionObj.conditionId==0 || (batchInspectionObj.conditionId==9 && (batchInspectionObj.reasonCode1=='' || !batchInspectionObj.scrappedDate))">
            Please fill out all required fields. Fields marked with * are mandatory.
          </label>
        </div>

        <button class="btn btn-falcon-default btn-sm" type="button" (click)="modalBatchInspectionClose()">Close</button>
        <button class="btn btn-primary btn-sm" id="btn_bsave" type="button" [disabled]="batchInspectionObj.refCode=='' || batchInspectionObj.typeId==0 || !batchInspectionObj._date || batchInspectionObj.inspectorId==0 || batchInspectionObj.conditionId==0 || (batchInspectionObj.conditionId==9 && (batchInspectionObj.reasonCode1=='' || !batchInspectionObj.scrappedDate))" (click)="saveBatchInspection()">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
<!---->
<!-- Modal Files-->
<div class="modal fade z-index10000  px-0" style="padding-left:0!important;padding-right:0!important" id="modal_files" tabindex="-1" role="dialog" aria-labelledby="modal_files" data-backdrop="static" data-keyboard="true"
     aria-hidden="true">
  <div class="d-flex justify-content-center align-items-center w-100 h-100">
    <div class="modal-dialog modal-width-700px width-100-per" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="mb-0 modal-title" id="exampleModalLabel">
            Files
            <br />
          </h5>
          <button class="close" type="button" aria-label="Close" id="X-ModalActivity" data-dismiss="modal">
            <span class="font-weight-light" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="padding: 1rem 2rem !important;">
          <div class="row">
            <div class="col-lg-5" *ngIf="fileId==0">
              <div class="media">
                <div>
                  <div class="form-group cursor-pointer">
                    <input type="file" #myfileInput id="myfileInput" class="form-control-file cursor-pointer" (change)="handleFileInput($event,$event.target.files)" />
                    <span class="text-muted fs-12">Files must be less than 50Mb.</span>
                  </div>
                  <div class="progressbar" *ngIf="showProgress">
                    <div class="progressbar__status" [style.width]="progressWidth"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-5">
              <div class="media">
                <div style="width:90%">
                  <div class="form-group">
                    <textarea class="form-control form-control-sm" placeholder="Description" rows="2" [(ngModel)]="fileDesc" maxLength="150"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-2">
              <button type="button" class="btn btn-sm btn-primary mt-2" (click)="addFile(fileDesc,fileType)" [disabled]="!uploadedFile">Add</button>
            </div>
          </div>

          <div class="file-body">
            <div class="file-row" *ngFor="let f of fileObjTemp; let i = index" [hidden]="f.ope==-1 || f._type!=fileType">
              <div class="file-icon">
                <i class="fas fa-file"></i>
              </div>

              <div class="file-info">
                <div class="file-top">
                  <span class="file-name">{{f.name}}</span>
                  <span class="file-size">{{ formatFileSize(f.size) }}</span>
                </div>

                <div class="file-desc">
                  {{f._desc}}
                </div>
              </div>

              <div class="file-actions">

                <button class="action-btn" title="Download" [disabled]="!f._url" (click)="downloadFile(f._url,f.name)">
                  <i class="fas fa-download"></i>
                </button>

                <button class="action-btn" title="Remove" (click)="deleteFile(i)">
                  <i class="fas fa-trash-alt"></i>
                </button>
              </div>
            </div>
          </div>




        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button class="btn-falcon-default btn-sm btn" data-dismiss="modal">Close</button>
          <button class="btn btn-primary btn-sm" id="btnFileSave" (click)="okFile()" [disabled]="fileListOpe">
            <div class="g_spinner" *ngIf="spinner"></div>OK
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!---->
<!-- Modal Delete-->
<div class="modal fade z-index10001 pr-0" style="padding-right:0!important" id="modalDelete" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
     data-backdrop="static" data-keyboard="false" aria-hidden="true" (keydown.esc)="modalDeleteClose()">
  <div class="modal-dialog modal-dialog-center modal-delete-width" role="document">
    <div class="modal-content">
      <div class="modal-header" style="border-bottom: none">
        <div class="modal-delete-header-icondiv">
          <i class="far fa-times-circle text-center modal-delete-circle-icon"></i>
        </div>
        <button class="close" type="button" data-dismiss="modal" aria-label="Close"
                (click)="modalDeleteClose()">
          <span class="font-weight-light" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="text-center fs-20 fw-600">Are you sure?</p>
        <p class="text-muted fs-13 pl-3 pr-3 text-center">Do you really want to delete {{delCount==1 ? 'this record' : 'these records'}}? This process can not be undone.</p>
      </div>
      <div class="modal-delete-footer">
        <button class="btn btn-sm mr-2 modal-delete-footer-cancel" type="button" data-dismiss="modal" (click)="modalDeleteClose()">Cancel</button>
        <button class="btn btn-danger btn-sm" type="button" (click)="deleteItem(delId,delType,delType2,delBulkArray)">Delete</button>
      </div>
    </div>
  </div>
</div>
<!---->
<!-- Modal Speccode-->
<div class="modal fade" id="speccodeModal" tabindex="-1" role="dialog" aria-labelledby="speccodeModal" data-backdrop="static" data-keyboard="false"
     aria-hidden="true" (keydown.esc)="modalSpeccodeClose()">
  <div class="modal-dialog modal-width-1150px ui-draggable" role="document">
    <div class="modal-content ">
      <div class="modal-header">
        <h5 class="modal-title">{{modalTitleSpeccode}}</h5>
        <button class="close" type="button" aria-label="Close" (click)="modalSpeccodeClose()">
          <span class="font-weight-light" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body " id="speccodeBody" style="padding: 1rem 2rem !important;">
        <div class="row">
          <div class="col-6">

            <div class="d-flex justify-content-md-between">
              <h6>Hose </h6>
              <a class="fs-14" href="javascript:void(0)" (click)="newHose()">Add New</a>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_scHoseCode" class="fs-12 mb-0 text400">
                  Hose
                </label>
              </div>
              <div class="col-3">
                <input type="text" name="txt_scHoseCode" id="txt_scHoseCode" class="form-control form-control-sm" title="Hose Code" tabindex="1" autocomplete="on" (focusout)="getAssemblyDataByCode(speccodeObjClone.hoseCode, 'hose')" [(ngModel)]="speccodeObjClone.hoseCode" />
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_scHose" name="slc_scHose" title="Hose" tabindex="2" (change)="codeById(speccodeObjClone.hoseId,'hose')" [(ngModel)]="speccodeObjClone.hoseId">
                  <option value="0">Choose</option>
                  <option value="{{h.id}}" *ngFor="let h of speccodeObjClone.hoseObj">{{h.name}}</option>
                </select>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_scBoreCode" class="fs-12 mb-0 text400">
                  Bore
                </label>
              </div>
              <div class="col-3">
                <input type="text" name="txt_scBoreCode" id="txt_scBoreCode" class="form-control form-control-sm" title="Bore Code" (focusout)="getAssemblyDataByCode(speccodeObjClone.boreCode, 'bore')" [(ngModel)]="speccodeObjClone.boreCode" tabindex="3" autocomplete="on" />
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_scBore" name="slc_scBore" title="Bore" tabindex="4" (change)="codeById(speccodeObjClone.boreId,'bore')" [(ngModel)]="speccodeObjClone.boreId">
                  <option value="0">Choose</option>
                  <option value="{{b.id}}" *ngFor="let b of speccodeObjClone.boreObj">{{b.name}}</option>
                </select>
              </div>
            </div>


            <h6>End 1</h6>
            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_scEndStyleCode1" class="fs-12 mb-0 text400">
                  End Style
                </label>
              </div>
              <div class="col-3">
                <input type="text" name="txt_scEndStyleCode1" id="txt_scEndStyleCode1" class="form-control form-control-sm" title="End Style 1 Code" tabindex="5" autocomplete="on" (focusout)="getAssemblyDataByCode(speccodeObjClone.endStyleCode1, 'endStyle1')" [(ngModel)]="speccodeObjClone.endStyleCode1" />
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_scEndStyle1" name="slc_scEndStyle1" title="End Style" tabindex="6" (change)="codeById(speccodeObjClone.endStyleId1,'endStyle1')" [(ngModel)]="speccodeObjClone.endStyleId1">
                  <option value="0">Choose</option>
                  <option value="{{e1.id}}" *ngFor="let e1 of speccodeObjClone.endObj">{{e1.name}}</option>
                </select>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_scThreadSizeCode1" class="fs-12 mb-0 text400">
                  Thread Size
                </label>
              </div>
              <div class="col-3">
                <input type="text" name="txt_scThreadSizeCode1" id="txt_scThreadSizeCode1" class="form-control form-control-sm" title="Thread Size 1 Code" tabindex="7" autocomplete="on" (focusout)="getAssemblyDataByCode(speccodeObjClone.threadSizeCode1, 'thread1')" [(ngModel)]="speccodeObjClone.threadSizeCode1" />
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_scThreadSize1" name="slc_scThreadSize1" title="Thread Size" tabindex="8" (change)="codeById(speccodeObjClone.threadSizeId1,'thread1')" [(ngModel)]="speccodeObjClone.threadSizeId1">
                  <option value="0">Choose</option>
                  <option value="{{t1.id}}" *ngFor="let t1 of speccodeObjClone.threadObj">{{t1.name}}</option>
                </select>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_scInsertTypeCode1" class="fs-12 mb-0 text400">
                  Insert Type
                </label>
              </div>
              <div class="col-3">
                <input type="text" name="txt_scInsertTypeCode1" id="txt_scInsertTypeCode1" class="form-control form-control-sm" title="Insert Type 1 Code" tabindex="9" autocomplete="on" (focusout)="getAssemblyDataByCode(speccodeObjClone.insertTypeCode1, 'insert1')" [(ngModel)]="speccodeObjClone.insertTypeCode1" />
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_scInsertType1" name="slc_scInsertType1" title="Insert Type" tabindex="10" (change)="codeById(speccodeObjClone.insertTypeId1,'insert1')" [(ngModel)]="speccodeObjClone.insertTypeId1">
                  <option value="0">Choose</option>
                  <option value="{{i1.id}}" *ngFor="let i1 of speccodeObjClone.insertObj">{{i1.name}}</option>
                </select>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_scRetentionTypeCode1" class="fs-12 mb-0 text400">
                  Retention Type
                </label>
              </div>
              <div class="col-3">
                <input type="text" name="txt_scRetentionTypeCode1" id="txt_scRetentionTypeCode1" class="form-control form-control-sm" title="Retention Type 1 Code" tabindex="11" autocomplete="on" (focusout)="getAssemblyDataByCode(speccodeObjClone.retentionTypeCode1, 'retention1')" [(ngModel)]="speccodeObjClone.retentionTypeCode1" />
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_scRetentionType1" name="slc_scRetentionType1" title="Retention Type" tabindex="12" (change)="codeById(speccodeObjClone.retentionTypeId1,'retention1')" [(ngModel)]="speccodeObjClone.retentionTypeId1">
                  <option value="0">Choose</option>
                  <option value="{{r1.id}}" *ngFor="let r1 of speccodeObjClone.retentionObj">{{r1.name}}</option>
                </select>
              </div>
            </div>




            <div class="row mb-1">
              <div class="col-12 d-flex align-items-center">
                <input type="checkbox" name="chb_sameEnds" id="chb_sameEnds" title="Both Ends the same" (change)="changeSameEndsOpe(speccodeObjClone.sameEndsOpe)" tabindex="21" [(ngModel)]="speccodeObjClone.sameEndsOpe" />
                <label for="chb_sameEnds" style="margin-bottom: -1px; margin-left: 5px;" class="fs-12 mb-0 text400">
                  Both Ends the same
                </label>
              </div>


            </div>


            <h6>End 2</h6>
            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_scEndStyleCode2" class="fs-12 mb-0 text400">
                  End Style
                </label>
              </div>
              <div class="col-3">
                <input type="text" name="txt_scEndStyleCode2" id="txt_scEndStyleCode2" class="form-control form-control-sm" title="End Style 2 Code" tabindex="13" (focusout)="getAssemblyDataByCode(speccodeObjClone.endStyleCode2, 'endStyle2')" autocomplete="on" [(ngModel)]="speccodeObjClone.endStyleCode2" />
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_scEndStyle2" name="slc_scEndStyle2" title="End Style" tabindex="14" (change)="codeById(speccodeObjClone.endStyleId2,'endStyle2')" [(ngModel)]="speccodeObjClone.endStyleId2">
                  <option value="0">Choose</option>
                  <option value="{{e2.id}}" *ngFor="let e2 of speccodeObjClone.endObj">{{e2.name}}</option>
                </select>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_scThreadSizeCode2" class="fs-12 mb-0 text400">
                  Thread Size
                </label>
              </div>
              <div class="col-3">
                <input type="text" name="txt_scThreadSizeCode2" id="txt_scThreadSizeCode2" class="form-control form-control-sm" title="Thread Size 2 Code" tabindex="15" autocomplete="on" (focusout)="getAssemblyDataByCode(speccodeObjClone.threadSizeCode2, 'thread2')" [(ngModel)]="speccodeObjClone.threadSizeCode2" />
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_scThreadSize2" name="slc_scThreadSize2" title="Thread Size" tabindex="16" (change)="codeById(speccodeObjClone.threadSizeId2,'thread2')" [(ngModel)]="speccodeObjClone.threadSizeId2">
                  <option value="0">Choose</option>
                  <option value="{{t2.id}}" *ngFor="let t2 of speccodeObjClone.threadObj">{{t2.name}}</option>
                </select>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_scInsertTypeCode2" class="fs-12 mb-0 text400">
                  Insert Type
                </label>
              </div>
              <div class="col-3">
                <input type="text" name="txt_scInsertTypeCode2" id="txt_scInsertTypeCode2" class="form-control form-control-sm" title="Insert Type 2 Code" tabindex="17" autocomplete="on" (focusout)="getAssemblyDataByCode(speccodeObjClone.insertTypeCode2, 'insert2')" [(ngModel)]="speccodeObjClone.insertTypeCode2" />
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_scInsertType2" name="slc_scInsertType2" title="Insert Type" tabindex="18" (change)="codeById(speccodeObjClone.insertTypeId2,'insert2')" [(ngModel)]="speccodeObjClone.insertTypeId2">
                  <option value="0">Choose</option>
                  <option value="{{i2.id}}" *ngFor="let i2 of speccodeObjClone.insertObj">{{i2.name}}</option>
                </select>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_scRetentionTypeCode2" class="fs-12 mb-0 text400">
                  Retention Type
                </label>
              </div>
              <div class="col-3">
                <input type="text" name="txt_scRetentionTypeCode2" id="txt_scRetentionTypeCode2" class="form-control form-control-sm" title="Retention Type 2 Code" tabindex="19" autocomplete="on" (focusout)="getAssemblyDataByCode(speccodeObjClone.retentionTypeCode2, 'retention2')" [(ngModel)]="speccodeObjClone.retentionTypeCode2" />
              </div>
              <div class="col-6">
                <select class="form-control form-control-sm select2" id="slc_scRetentionType2" name="slc_scRetentionType2" title="Retention Type" tabindex="20" (change)="codeById(speccodeObjClone.retentionTypeId2,'retention2')" [(ngModel)]="speccodeObjClone.retentionTypeId2">
                  <option value="0">Choose</option>
                  <option value="{{r2.id}}" *ngFor="let r2 of speccodeObjClone.retentionObj">{{r2.name}}</option>
                </select>
              </div>
            </div>


            <h6>Length & Orientation</h6>
            <div class="row mb-1">

              <div class="col-3 text-right">
                <label for="txt_scLength" class="fs-12 mb-0 text400">
                  Length
                </label>
              </div>
              <div class="col-3">
                <input type="number" name="txt_scLength" id="txt_scLength" class="form-control form-control-sm" title="Legth" tabindex="21" autocomplete="on" [(ngModel)]="speccodeObjClone._length" />
              </div>
              <div class="col-3 text-right">
                <label for="txt_scEndStyleCode2" class="fs-12 mb-0 text400">
                  Orientation
                </label>
              </div>
              <div class="col-3">
                <input type="number" name="txt_scOrientation" id="txt_scOrientation" class="form-control form-control-sm" title="Orientation" tabindex="22" autocomplete="on" [(ngModel)]="speccodeObjClone._orientation" />
              </div>
            </div>





            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_specCode_" class="fs-12 mb-0 text400">
                  Spec Code
                </label>
              </div>
              <div class="col-9">
                <input type="text" name="txt_specCode_" id="txt_specCode_" class="form-control form-control-sm" title="Spec Code" tabindex="23" autocomplete="on" [(ngModel)]="speccodeObjClone.specCode" />
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 text-right">
                <label for="txt_specCodeDesc_" class="fs-12 mb-0 text400 text-nowrap">
                  Description
                </label>
              </div>
              <div class="col-9">
                <textarea name="txt_specCodeDesc_" id="txt_specCodeDesc_" class="form-control form-control-sm" rows="4" title="Spec Code Description" tabindex="24" autocomplete="on" [(ngModel)]="speccodeObjClone.specCodeDesc"></textarea>
              </div>
            </div>




          </div>







          <div class="col-6">




            <h6>Options</h6>
            <div class="row mb-1">

              <div class="col-12">

                <table class="table table-sm mb-0 table-striped border-bottom" style="height: 570px; overflow-y: auto;display:block">
                  <thead class="bg-200 text-900 sticky-header">
                    <tr>
                      <th class="fs-12 text-center">Use</th>
                      <th class="fs-12 text-left">Option</th>
                      <th class="fs-12 text-center">End1</th>
                      <th class="fs-12 text-center">End2</th>
                      <th class="fs-12 text-center">Each End</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let o of speccodeObjClone.optionObj">
                      <td class="text-center"><input type="checkbox" [(ngModel)]="o.ope" /></td>
                      <td class="text-left">{{o.name}}</td>
                      <td class="text-center"><input type="checkbox" [(ngModel)]="o.end1" /></td>
                      <td class="text-center"><input type="checkbox" [(ngModel)]="o.end2" /></td>
                      <td class="text-center"><input type="checkbox" [(ngModel)]="o.eachEnd" /></td>
                    </tr>
                  </tbody>
                </table>






              </div>
            </div>














          </div>











        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-success btn-sm" id="btn_speccode" type="button" (click)="generateSpeccode()">
          Generate Speccode
        </button>
        <button class="btn btn-falcon-default btn-sm" type="button" (click)="modalSpeccodeClose()">Close</button>
        <button class="btn btn-primary btn-sm" id="btn_bsave" type="button" (click)="saveSpeccode()">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
<!---->
<!-- Modal Hose-->
<div class="modal fade" id="hoseModal" tabindex="-1" role="dialog" aria-labelledby="hoseModal" data-backdrop="static" data-keyboard="false"
     aria-hidden="true" (keydown.esc)="modalHoseClose()">
  <div class="modal-dialog modal-width-500px ui-draggable" role="document">
    <div class="modal-content ">
      <div class="modal-header">
        <h5 class="modal-title">New Hose</h5>
        <button class="close" type="button" aria-label="Close" (click)="modalHoseClose()">
          <span class="font-weight-light" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body " id="hoseBody" style="padding: 1rem 2rem !important;">
          <div class="row mb-2">
            <div class="col-3 text-right">
              <label for="txt_scHoseCode" class="fs-12 mb-0 text400">
                Hose Code
              </label>
            </div>
            <div class="col-9">
              <input type="text" name="txt_HoseCode_" id="txt_HoseCode_" class="form-control form-control-sm" title="Hose Code" tabindex="1" autocomplete="on" [(ngModel)]="hoseCode" />
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-3 text-right">
              <label for="txt_scHoseCode" class="fs-12 mb-0 text400">
                Hose Name
              </label>
            </div>
            <div class="col-9">
              <input type="text" name="txt_HoseName_" id="txt_HoseName_" class="form-control form-control-sm" title="Hose Name" tabindex="2" autocomplete="on" [(ngModel)]="hoseName" />
            </div>
          </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-falcon-default btn-sm" type="button" (click)="modalHoseClose()">Close</button>
        <button class="btn btn-primary btn-sm" id="btn_bsave" type="button" (click)="saveHose()">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
<!---->
